export const emptyVNode = {
  type: "comment",
  attributes: {},
  children: null,
  content: "",
  node: document.createComment(""),
}
